import axiosInstance from 'axios'
import { AxiosRequestConfig } from 'axios'

const getCsrfToken = () =>
  document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content

export const request = <R = any, D = any>(url: string, options?: AxiosRequestConfig<D>): Promise<R> =>
  axiosInstance.request({
    url,
    ...options,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
      'X-Requested-With': 'XMLHttpRequest',
      ...options?.headers,
    },
  })

export default request
